import React, { useState, useRef, useEffect, useReducer, forwardRef } from 'react';
import { Checkbox, Row, Col, Counter, Text as Text$1, Button as Button$1, Icon, Spinner as Spinner$1, EIconNames, Image as Image$1, Form as Form$2, FormItem as FormItem$1, FormList as FormList$1, regexPatterns, Input as Input$1, PasswordInput as PasswordInput$1, TextArea as TextArea$1, PhoneInput as PhoneInput$1, Title as Title$1, SecondaryText as SecondaryText$1, Link as Link$1, Paragraph as Paragraph$1, MessageLabel as MessageLabel$1, VerificationCode as VerificationCode$1, Avatar as Avatar$1, Divider as Divider$1, Card as Card$1, Space as Space$1, Collapse as Collapse$1, Tag as Tag$1, CheckableTag as CheckableTag$1, ENotificationType, TextIcon as TextIcon$1, EmptyView as EmptyView$1, QRCode as QRCode$1, Switch as Switch$1, Modal as Modal$1, requiredAsteriskStyles } from '@idaho-aeyc/ui-kit';
export { Col, ENotificationType, Row } from '@idaho-aeyc/ui-kit';
import { Form as Form$1, App } from 'antd';
import { _ as _object_without_properties_loose, a as _extends, b as _tagged_template_literal_loose, c as _async_to_generator, d as _ts_generator, e as _object_destructuring_empty } from './cc-DVmW_bAy.mjs';
import { useTranslation as useTranslation$1 } from 'react-i18next';
export { Trans } from 'react-i18next';
import styled, { useTheme, styled as styled$1 } from 'styled-components';
import dayjs from 'dayjs';

var AntdForm = Form$1.useForm;
var useForm = function useForm(initialValues) {
    var _AntdForm = AntdForm(initialValues), form = _AntdForm[0];
    var setFieldsValue = form.setFieldsValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var setCustomFieldValue = function setCustomFieldValue(fieldName, customValue) {
        var _obj;
        // @ts-ignore
        setFieldsValue((_obj = {}, _obj[fieldName] = customValue, _obj)); // Todo : find solution
    };
    return {
        setCustomFieldValue: setCustomFieldValue,
        form: form
    };
};

var EI18nLanguageUI = /*#__PURE__*/ function(EI18nLanguageUI) {
    EI18nLanguageUI["ENGLISH"] = "en";
    EI18nLanguageUI["SPANISH"] = "es";
    return EI18nLanguageUI;
}({});
var EWorkshopChildcareAgeGroups = /*#__PURE__*/ function(EWorkshopChildcareAgeGroups) {
    EWorkshopChildcareAgeGroups["ONE_TO_TWO"] = "ONE_TO_TWO";
    EWorkshopChildcareAgeGroups["THREE_TO_FIVE"] = "THREE_TO_FIVE";
    EWorkshopChildcareAgeGroups["SIX_TO_TWELVE"] = "SIX_TO_TWELVE";
    return EWorkshopChildcareAgeGroups;
}({});

var useTranslation = function useTranslation(// eslint-disable-next-line @typescript-eslint/no-explicit-any
options) {
    var defaultCustomOptions = {
        lng: EI18nLanguageUI.ENGLISH,
        namespace: 'translation'
    };
    var language = EI18nLanguageUI.ENGLISH;
    var _ref = options || {}, namespace = _ref.namespace, lng = _ref.lng, rest = _object_without_properties_loose(_ref, [
        "namespace",
        "lng"
    ]);
    if (lng === 'translate') {
        language = undefined;
    } else if (lng) {
        language = lng;
    }
    var ns = namespace || defaultCustomOptions.namespace;
    var extendedOptions = _extends({}, rest, {
        lng: language
    });
    return useTranslation$1(ns, extendedOptions);
};

// Hooks for safe state update during ansyncronous actions if component unmount.
var useStateSafely = function useStateSafely(initialValue) {
    var _useState = useState(initialValue), value = _useState[0], setValue = _useState[1];
    var isSafe = useRef(true);
    useEffect(function() {
        isSafe.current = true;
        return function() {
            isSafe.current = false;
        };
    }, []);
    var setValueSafely = function setValueSafely(newValue) {
        if (isSafe.current) {
            setValue(newValue);
        }
    };
    return [
        value,
        setValueSafely
    ];
};
var useStateSafelyNoParams = function useStateSafelyNoParams(initialValue) {
    var _useState = useState(initialValue), value = _useState[0], setValue = _useState[1];
    var isSafe = useRef(true);
    useEffect(function() {
        isSafe.current = true;
        return function() {
            isSafe.current = false;
        };
    }, []);
    var setValueSafely = function setValueSafely(newValue) {
        if (isSafe.current) {
            setValue(newValue);
        }
    };
    return [
        value,
        setValueSafely
    ];
};

var useScreenSize = function useScreenSize() {
    var _useState = useState({
        width: window.innerWidth,
        height: window.innerHeight
    }), screenSize = _useState[0], setScreenSize = _useState[1];
    useEffect(function() {
        var handleResize = function handleResize() {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener('resize', handleResize);
        // Cleanup the event listener on unmount
        return function() {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array to ensure the effect runs only once
    return screenSize;
};

function _templateObject$i() {
    var data = _tagged_template_literal_loose([
        "\n  &&& {\n    .ant-checkbox-checked {\n      border-spacing: initial;\n    }\n  }\n"
    ]);
    _templateObject$i = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1$4() {
    var data = _tagged_template_literal_loose([
        "\n  & {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject1$4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2$3() {
    var data = _tagged_template_literal_loose([
        "\n  & {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject2$3 = function _templateObject() {
        return data;
    };
    return data;
}
var SCeckbox = styled(Checkbox)(_templateObject$i());
var SColumnRow = styled(Row)(_templateObject1$4());
var SEditChildcareWrapper = styled(Row)(_templateObject2$3(), function(param) {
    var width = param.width;
    return width ? "" + width + "px" : '100%';
});

var EditChildcareItem = function EditChildcareItem(param) {
    var childcareItem = param.childcareItem, onCheckboxChange = param.onCheckboxChange, counterOnChange = param.counterOnChange, _param_translationLanguage = param.translationLanguage, translationLanguage = _param_translationLanguage === void 0 ? EI18nLanguageUI.ENGLISH : _param_translationLanguage;
    var t = useTranslation({
        lng: translationLanguage
    }).t;
    return /*#__PURE__*/ React.createElement(Row, {
        align: "middle",
        justify: "space-between"
    }, /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(SCeckbox, {
        onChange: onCheckboxChange,
        checked: childcareItem.checked
    }, t('descriptions.input-labels.AGES'), ' ', t("enums.childcare-age-group." + childcareItem.name))), /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(Counter, {
        onChange: counterOnChange,
        disabled: !childcareItem.checked,
        defaultValue: childcareItem.value || 0,
        minValue: 1,
        wrapperPadding: "4px 16px"
    })));
};

var EEditChildcareReducerActions = /*#__PURE__*/ function(EEditChildcareReducerActions) {
    EEditChildcareReducerActions["CHECKBOX_CHANGE"] = "CHECKBOX_CHANGE";
    EEditChildcareReducerActions["COUNTER_CHANGE"] = "COUNTER_CHANGE";
    EEditChildcareReducerActions["RESET"] = "RESET";
    return EEditChildcareReducerActions;
}({});
var initialState = Object.values(EWorkshopChildcareAgeGroups).map(function(item) {
    return {
        name: item,
        checked: false,
        value: 0
    };
});
var reducer = function reducer(state, action) {
    switch(action.type){
        case "CHECKBOX_CHANGE":
            return state.map(function(item) {
                if (item.name === action.name) {
                    return _extends({}, item, {
                        checked: action.checked,
                        value: action.checked ? 1 : 0
                    });
                }
                return item;
            });
        case "COUNTER_CHANGE":
            return state.map(function(item) {
                if (item.name === action.name) {
                    return _extends({}, item, {
                        value: action.value
                    });
                }
                return item;
            });
        case "RESET":
            return initialState;
        default:
            return state;
    }
};

var EditChildcare = function EditChildcare(param) {
    var initialChildcare = param.initialChildcare, onChange = param.onChange, translationLanguage = param.translationLanguage, width = param.width;
    var _useReducer = useReducer(reducer, initialChildcare || initialState), childcare = _useReducer[0], dispatch = _useReducer[1];
    var onCheckboxChange = function onCheckboxChange(e, name) {
        var checked = e.target.checked;
        dispatch({
            type: EEditChildcareReducerActions.CHECKBOX_CHANGE,
            name: name,
            checked: checked
        });
    };
    var onCounterChange = function onCounterChange(value, name) {
        dispatch({
            type: EEditChildcareReducerActions.COUNTER_CHANGE,
            name: name,
            value: value
        });
    };
    useEffect(function() {
        if (onChange) {
            onChange(childcare);
        }
    }, [
        childcare,
        onChange
    ]);
    // max with is modal width
    return /*#__PURE__*/ React.createElement(SEditChildcareWrapper, {
        gutter: [
            0,
            4
        ],
        width: width
    }, childcare.map(function(item) {
        return /*#__PURE__*/ React.createElement(Col, {
            key: item.name,
            span: 24
        }, /*#__PURE__*/ React.createElement(EditChildcareItem, {
            childcareItem: item,
            onCheckboxChange: function onCheckboxChange1(value) {
                return onCheckboxChange(value, item.name);
            },
            counterOnChange: function counterOnChange(value) {
                return onCounterChange(value, item.name);
            },
            translationLanguage: translationLanguage
        }));
    }));
};

var ChildcareView = function ChildcareView(param) {
    var childcareItems = param.childcareItems;
    var t = useTranslation({
        keyPrefix: 'enums.childcare-age-group'
    }).t;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var theme = useTheme();
    if (!childcareItems.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SColumnRow, {
        gutter: [
            0,
            8
        ],
        wrap: false
    }, childcareItems.map(function(childcareItem) {
        return /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(Row, {
            gutter: [
                8,
                0
            ],
            wrap: false
        }, /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(Text$1, {
            fontWeight: theme.fontWeightSemiBold,
            fontSize: theme.fontSizeLg,
            color: theme.colorPrimaryDefault
        }, t(childcareItem.name), ":")), /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(Text$1, {
            fontWeight: theme.fontWeightRegular
        }, childcareItem.value || 0))));
    }));
};

var ActionButton = function ActionButton(param) {
    var icon = param.icon, tooltipTitle = param.tooltipTitle, onClick = param.onClick;
    return /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(Button$1, {
        icon: /*#__PURE__*/ React.createElement(Icon, {
            alt: "icon",
            icon: icon,
            size: 14,
            className: "pointer"
        }),
        tooltip: tooltipTitle,
        onClick: onClick,
        color: "primary",
        shape: "circle",
        size: "middle"
    }));
};

var useOutsideClick = function useOutsideClick(ref, onOutsideClick, conditionToTrigger) {
    useEffect(function() {
        var handleClickOutside = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                if (conditionToTrigger) {
                    onOutsideClick();
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function() {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        onOutsideClick
    ]);
};

var EditableContentWithActions = function EditableContentWithActions(param) {
    var onSave = param.onSave, onCancel = param.onCancel, onEdit = param.onEdit, readView = param.readView, editView = param.editView, wrapperClassName = param.wrapperClassName, wrapperSytle = param.wrapperSytle, isLoading = param.isLoading, isReadOnly = param.isReadOnly;
    var t = useTranslation({
        keyPrefix: 'descriptions.admin-portal.workshops.details.child-care.table.actions'
    }).t;
    var _useState = useState(false), isEditView = _useState[0], setIsEditView = _useState[1];
    var onSaveClick = function onSaveClick() {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSave()
                        ];
                    case 1:
                        _state.sent();
                        setIsEditView(false);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var onCancelClick = function onCancelClick() {
        setIsEditView(false);
        if (onCancel) onCancel();
    };
    var onEditClick = function onEditClick() {
        setIsEditView(true);
        if (onEdit) onEdit();
    };
    var wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, onSaveClick, isEditView);
    return /*#__PURE__*/ React.createElement(Spinner$1, {
        spinning: !!isLoading
    }, /*#__PURE__*/ React.createElement(Row, {
        style: wrapperSytle,
        className: wrapperClassName,
        justify: "space-between",
        align: "middle",
        wrap: false,
        ref: wrapperRef
    }, /*#__PURE__*/ React.createElement(Col, null, isEditView ? editView : readView), !isReadOnly && /*#__PURE__*/ React.createElement(Col, null, isEditView ? /*#__PURE__*/ React.createElement(Row, {
        gutter: [
            8,
            8
        ],
        wrap: false
    }, /*#__PURE__*/ React.createElement(ActionButton, {
        icon: EIconNames.CHECK,
        tooltipTitle: t('SAVE'),
        onClick: onSaveClick
    }), /*#__PURE__*/ React.createElement(ActionButton, {
        icon: EIconNames.CLOSE,
        tooltipTitle: t('CANCEL'),
        onClick: onCancelClick
    })) : /*#__PURE__*/ React.createElement(ActionButton, {
        icon: EIconNames.EDIT_FILLED,
        tooltipTitle: t('EDIT'),
        onClick: onEditClick
    }))));
};

function _templateObject$h() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$h = function _templateObject() {
        return data;
    };
    return data;
}
var SImage = styled$1(Image$1)(_templateObject$h());

var Image = function Image(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SImage, props);
};

function _templateObject$g() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$g = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1$3() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject1$3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2$2() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject2$2 = function _templateObject() {
        return data;
    };
    return data;
}
var SForm = styled$1(Form$2)(_templateObject$g());
var SFormItem = styled$1(FormItem$1)(_templateObject1$3());
var SFormList = styled$1(FormList$1)(_templateObject2$2());

var Form = function Form(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SForm, props);
};
var FormItem = function FormItem(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SFormItem, props);
};
var FormList = function FormList(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SFormList, props);
};

var useGetValidationData = function useGetValidationData() {
    var t = useTranslation({
        keyPrefix: 'descriptions.validation-errors'
    }).t;
    var EValidationMessages = {
        NEGATIVE_IMPOSSIBLE: t('NEGATIVE_IMPOSSIBLE'),
        ONLY_NUMBERS: t('ONLY_NUMBERS'),
        DECREASE_IMPOSSIBLE: t('DECREASE_IMPOSSIBLE'),
        THIS_FIELD_IS_REQUIRED: t('THIS_FIELD_IS_REQUIRED'),
        INCORRECT_EMAIL_ADDRESS: t('INCORRECT_EMAIL_ADDRESS'),
        INVALID_PHONE_FORMAT: t('INVALID_PHONE_FORMAT'),
        CANT_START_WITH_SPACE: t('CANT_START_WITH_SPACE'),
        ACCEPT_TERMS_AND_CONDITIONS: t('ACCEPT_TERMS_AND_CONDITIONS'),
        PASSWORD_DONT_MATCH: t('PASSWORD_DONT_MATCH'),
        END_DATE_MUST_BE_LATER: t('END_DATE_MUST_BE_LATER'),
        START_DATE_MUST_BE_EARLIER: t('START_DATE_MUST_BE_EARLIER'),
        START_END_SHOULD_DIFFER: t('START_END_SHOULD_DIFFER'),
        END_START_SHOULD_DIFFER: t('END_START_SHOULD_DIFFER'),
        END_SHOULD_BE_LATER: t('END_SHOULD_BE_LATER'),
        START_SHOULD_BE_EARLIER: t('START_SHOULD_BE_EARLIER'),
        VALUE_SHOULDNT_BE_NEGATIVE: t('VALUE_SHOULDNT_BE_NEGATIVE'),
        VALUE_BETWEEN_0_AND_100: t('VALUE_BETWEEN_0_AND_100'),
        VALUE_SHOULD_BE_POSITIVE: t('VALUE_SHOULD_BE_POSITIVE'),
        VALUE_SHOULD_CONTAIN_ONE_DECIMAL: t('VALUE_SHOULD_CONTAIN_ONE_DECIMAL'),
        ONLY_ENGLISH_LETTERS_ALLOWED: t('ONLY_ENGLISH_LETTERS_ALLOWED'),
        PROVIDE_CORRECT_ADDRESS: t('PROVIDE_CORRECT_ADDRESS'),
        PROVIDE_ADDRESS_IN_IDAHO: t('PROVIDE_ADDRESS_IN_IDAHO'),
        INVALID_URL: t('INVALID_URL'),
        PASSWORD: t('PASSWORD'),
        MAX_LIMIT: t('MAX_LIMIT'),
        ZIP_TO_BE_A_NUMBER: t('ZIP_TO_BE_A_NUMBER'),
        ZIP_CANT_BE_LESS_THAN_FIVE_DIGITS: t('ZIP_CANT_BE_LESS_THAN_FIVE_DIGITS'),
        ZIP_CANT_BE_MORE_THAN_FIVE_DIGITS: t('ZIP_CANT_BE_MORE_THAN_FIVE_DIGITS')
    };
    var validationRules = {
        required: function required(fieldName) {
            return {
                validator: function validator(_, value) {
                    if (typeof value === 'string' && value.trim() || typeof value !== 'string' && !!value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(fieldName ? t('PLACEHOLDER_FIELD_IS_REQUIRED', {
                        placeholder: fieldName
                    }) : EValidationMessages.THIS_FIELD_IS_REQUIRED));
                }
            };
        },
        requiredField: function requiredField(fieldName) {
            return {
                required: true,
                message: fieldName ? t('PLACEHOLDER_FIELD_IS_REQUIRED', {
                    placeholder: fieldName
                }) : EValidationMessages.THIS_FIELD_IS_REQUIRED
            };
        },
        email: function email() {
            return {
                pattern: regexPatterns.email,
                message: EValidationMessages.INCORRECT_EMAIL_ADDRESS
            };
        },
        multipleEmails: function multipleEmails() {
            return {
                pattern: regexPatterns.emailsSeparatedWithComma,
                message: EValidationMessages.INCORRECT_EMAIL_ADDRESS
            };
        },
        phoneNumber: function phoneNumber() {
            return {
                pattern: regexPatterns.phoneNumber,
                message: EValidationMessages.INVALID_PHONE_FORMAT
            };
        },
        withoutSpace: function withoutSpace(fieldName) {
            return {
                validator: function validator(_, value) {
                    if (!regexPatterns.startEndWhiteSpace.test(value)) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(fieldName ? "" + fieldName + " can't start or end with white space!" : EValidationMessages.CANT_START_WITH_SPACE));
                }
            };
        },
        password: function password() {
            return {
                validator: function validator(_, value) {
                    var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*!:,;|])[\^$*!:,;|a-zA-Z\d]{8,}$/;
                    if (!value) {
                        return Promise.reject(new Error(EValidationMessages.THIS_FIELD_IS_REQUIRED));
                    }
                    if (regex.test(value)) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(EValidationMessages.PASSWORD));
                }
            };
        },
        acceptTerms: [
            {
                validator: function validator(_, value) {
                    if (value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(EValidationMessages.ACCEPT_TERMS_AND_CONDITIONS));
                }
            }
        ],
        passwordConfirm: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue;
                return {
                    validator: function validator(_, value) {
                        if (!value) {
                            return Promise.reject(new Error(EValidationMessages.THIS_FIELD_IS_REQUIRED));
                        }
                        if (getFieldValue('password') === value) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.PASSWORD_DONT_MATCH));
                    }
                };
            }
        ],
        startTime: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue, setFields = param.setFields;
                return {
                    validator: function validator(_, value) {
                        if (!value) {
                            return Promise.reject(new Error(EValidationMessages.THIS_FIELD_IS_REQUIRED));
                        }
                        if (dayjs(getFieldValue('endTime')).isSame(dayjs(value), 'minutes')) {
                            return Promise.reject(new Error(EValidationMessages.START_END_SHOULD_DIFFER));
                        }
                        if (!getFieldValue('endTime') || dayjs(getFieldValue('endTime')).isAfter(dayjs(value))) {
                            setFields([
                                {
                                    name: 'endTime',
                                    errors: []
                                }
                            ]);
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.START_DATE_MUST_BE_EARLIER));
                    }
                };
            }
        ],
        endTime: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue, setFields = param.setFields;
                return {
                    validator: function validator(_, value) {
                        if (!value) {
                            return Promise.reject(new Error(EValidationMessages.THIS_FIELD_IS_REQUIRED));
                        }
                        if (dayjs(getFieldValue('startTime')).isSame(dayjs(value), 'minutes')) {
                            return Promise.reject(new Error(EValidationMessages.END_START_SHOULD_DIFFER));
                        }
                        if (!getFieldValue('startTime') || dayjs(getFieldValue('startTime')).isBefore(dayjs(value))) {
                            setFields([
                                {
                                    name: 'startTime',
                                    errors: []
                                }
                            ]);
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.END_SHOULD_BE_LATER));
                    }
                };
            }
        ],
        startDate: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue, setFields = param.setFields;
                return {
                    validator: function validator(_, value) {
                        if (!value) {
                            return Promise.reject(new Error(EValidationMessages.THIS_FIELD_IS_REQUIRED));
                        }
                        if (!getFieldValue('endDate') || dayjs(getFieldValue('endDate')).isAfter(dayjs(value))) {
                            setFields([
                                {
                                    name: 'endDate',
                                    errors: []
                                }
                            ]);
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.START_SHOULD_BE_EARLIER));
                    }
                };
            }
        ],
        endDate: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue, setFields = param.setFields;
                return {
                    validator: function validator(_, value) {
                        if (!value) {
                            return Promise.reject(new Error(EValidationMessages.THIS_FIELD_IS_REQUIRED));
                        }
                        if (!getFieldValue('startDate') || dayjs(getFieldValue('startDate')).isBefore(dayjs(value))) {
                            setFields([
                                {
                                    name: 'startDate',
                                    errors: []
                                }
                            ]);
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.END_DATE_MUST_BE_LATER));
                    }
                };
            }
        ],
        endDateOptional: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue, setFields = param.setFields;
                return {
                    validator: function validator(_, value) {
                        if (!value) {
                            return Promise.resolve();
                        }
                        if (!getFieldValue('startDate') || dayjs(getFieldValue('startDate')).isBefore(dayjs(value))) {
                            setFields([
                                {
                                    name: 'startDate',
                                    errors: []
                                }
                            ]);
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.END_DATE_MUST_BE_LATER));
                    }
                };
            }
        ],
        startTimeOptional: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue, setFields = param.setFields;
                return {
                    validator: function validator(_, value) {
                        if (!getFieldValue('endTime') || dayjs(getFieldValue('endTime')).isAfter(dayjs(value))) {
                            setFields([
                                {
                                    name: 'endTime',
                                    errors: []
                                }
                            ]);
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.START_DATE_MUST_BE_EARLIER));
                    }
                };
            }
        ],
        endTimeOptional: [
            // @ts-ignore
            function(param) {
                var getFieldValue = param.getFieldValue, setFields = param.setFields;
                return {
                    validator: function validator(_, value) {
                        if (!getFieldValue('startTime') || dayjs(getFieldValue('startTime')).isBefore(dayjs(value))) {
                            setFields([
                                {
                                    name: 'startTime',
                                    errors: []
                                }
                            ]);
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(EValidationMessages.END_SHOULD_BE_LATER));
                    }
                };
            }
        ],
        integerMoreThanZeroOptional: function integerMoreThanZeroOptional() {
            return {
                validator: function validator(_, value) {
                    if (value > 0 || !value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(EValidationMessages.VALUE_SHOULDNT_BE_NEGATIVE));
                }
            };
        },
        integerFromZeroToHundred: function integerFromZeroToHundred() {
            return {
                validator: function validator(_, value) {
                    if (value >= 0 && value <= 100 || !value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(EValidationMessages.VALUE_BETWEEN_0_AND_100));
                }
            };
        },
        integerWithDecimalsRequired: function integerWithDecimalsRequired() {
            return {
                validator: function validator(_, value) {
                    if (!value || Number.isNaN(+value)) {
                        return Promise.reject(new Error(EValidationMessages.THIS_FIELD_IS_REQUIRED));
                    }
                    if (!value.match(/^[+-](\d*\.)?\d+$/g)) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(EValidationMessages.VALUE_SHOULD_BE_POSITIVE));
                }
            };
        },
        integerWithDecimalsOptional: function integerWithDecimalsOptional() {
            return {
                validator: function validator(_, value) {
                    if (!value.match(/^[+-](\d*\.)?\d+$/g)) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(EValidationMessages.VALUE_SHOULD_BE_POSITIVE));
                }
            };
        },
        integerOptional: function integerOptional() {
            return {
                validator: function validator(_, value) {
                    if (!value.match(/[^\d]/g)) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(EValidationMessages.VALUE_SHOULD_BE_POSITIVE));
                }
            };
        },
        onePointDecimal: function onePointDecimal() {
            return {
                validator: function validator(_, value) {
                    if (!!value && !!value.split('.')[1]) {
                        if (value.split('.')[1].length > 1) {
                            return Promise.reject(new Error(EValidationMessages.VALUE_SHOULD_CONTAIN_ONE_DECIMAL));
                        }
                    }
                    return Promise.resolve();
                }
            };
        },
        domainNameOptional: function domainNameOptional() {
            return {
                validator: function validator(_, value) {
                    if (!value || !value.length || value.every(function(item) {
                        return item.match(regexPatterns.domainName);
                    })) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error('Invalid domain name!'));
                }
            };
        },
        onlyEnglishLetters: function onlyEnglishLetters() {
            return {
                pattern: regexPatterns.onlyEnglishLetters,
                message: EValidationMessages.ONLY_ENGLISH_LETTERS_ALLOWED
            };
        },
        address: function address() {
            return {
                validator: function validator(_, value) {
                    if (Object.values(value).some(function(item) {
                        return !item;
                    })) {
                        return Promise.reject(new Error(EValidationMessages.PROVIDE_CORRECT_ADDRESS));
                    }
                    if (value.state && value.state.toLowerCase() !== 'idaho') {
                        return Promise.reject(new Error(EValidationMessages.PROVIDE_ADDRESS_IN_IDAHO));
                    }
                    return Promise.resolve();
                }
            };
        },
        validUrl: function validUrl() {
            return {
                validator: function validator(_, value) {
                    if (value) {
                        try {
                            // eslint-disable-next-line no-new
                            new URL(value);
                            return Promise.resolve();
                        } catch (error) {
                            return Promise.reject(new Error(EValidationMessages.INVALID_URL));
                        }
                    }
                    return Promise.resolve();
                }
            };
        },
        classCapacityValidation: function classCapacityValidation() {
            return {
                validator: function validator(_, value) {
                    if (!value) return Promise.resolve();
                    var numericValue = Number(value);
                    if (numericValue < 0) {
                        return Promise.reject(new Error(EValidationMessages.NEGATIVE_IMPOSSIBLE));
                    }
                    if (value.match(/[^\d]/g)) {
                        return Promise.reject(new Error(EValidationMessages.ONLY_NUMBERS));
                    }
                    // if (
                    //   workshopStatus === EWorkshopStatus.PUBLISHED &&
                    //   (number > numericValue || number === 0) // 0 is case when capacity is unlimited
                    // ) {
                    //   return Promise.reject(
                    //     new Error(EValidationMessages.DECREASE_IMPOSSIBLE),
                    //   );
                    // }
                    return Promise.resolve();
                }
            };
        },
        positiveNumbers: function positiveNumbers() {
            return {
                validator: function validator(_, value) {
                    if (!value) return Promise.resolve();
                    var numericValue = Number(value);
                    if (numericValue < 0) {
                        return Promise.reject(new Error(EValidationMessages.NEGATIVE_IMPOSSIBLE));
                    }
                    if (value.match(/[^\d]/g)) {
                        return Promise.reject(new Error(EValidationMessages.ONLY_NUMBERS));
                    }
                    return Promise.resolve();
                }
            };
        },
        maxLimit: function maxLimit(limit) {
            return {
                validator: function validator(_, value) {
                    if ((value == null ? void 0 : value.length) >= limit) {
                        // You can customize the validation message by overriding the message field when you call this validation rule. Like in CreateWorkshopSubscribersForm.data.ts file.
                        return Promise.reject(new Error(EValidationMessages.MAX_LIMIT));
                    }
                    return Promise.resolve();
                }
            };
        },
        zipCode: function zipCode() {
            return {
                validator: function validator(_, value) {
                    if (!value) return Promise.resolve();
                    if (value.match(/[^\d]/g)) {
                        return Promise.reject(new Error(EValidationMessages.ZIP_TO_BE_A_NUMBER));
                    }
                    if (value.length < 5) {
                        return Promise.reject(new Error(EValidationMessages.ZIP_CANT_BE_LESS_THAN_FIVE_DIGITS));
                    }
                    if (value.length > 5) {
                        return Promise.reject(new Error(EValidationMessages.ZIP_CANT_BE_MORE_THAN_FIVE_DIGITS));
                    }
                    return Promise.resolve();
                }
            };
        }
    };
    return {
        EValidationMessages: EValidationMessages,
        validationRules: validationRules
    };
};

function _templateObject1$2() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject1$2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2$1() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject2$1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3$1() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject3$1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4$1() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject4$1 = function _templateObject() {
        return data;
    };
    return data;
}
var SInput = styled(Input$1)(_templateObject1$2());
var SPassword = styled(PasswordInput$1)(_templateObject2$1());
var STextArea = styled(TextArea$1)(_templateObject3$1());
var SPhoneInput = styled(PhoneInput$1)(_templateObject4$1());

var Input = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ React.createElement(SInput, _extends({
        ref: ref
    }, props));
});
var PasswordInput = function PasswordInput(props) {
    return /*#__PURE__*/ React.createElement(SPassword, props);
};
var TextArea = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ React.createElement(STextArea, _extends({
        ref: ref
    }, props));
});
var PhoneInput = function PhoneInput(props) {
    return /*#__PURE__*/ React.createElement(SPhoneInput, props);
};

function _templateObject$f() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$f = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1$1() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject1$1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var STitle = styled(Title$1)(_templateObject$f());
var SText = styled(Text$1)(_templateObject1$1());
var SSecondaryText = styled(SecondaryText$1)(_templateObject2());
var SLink = styled(Link$1)(_templateObject3());
var SParagraph = styled(Paragraph$1)(_templateObject4());
var SMessageLabel = styled(MessageLabel$1)(_templateObject5());

var Title = function Title(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(STitle, props);
};
var Text = function Text(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SText, props);
};
var SecondaryText = function SecondaryText(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SSecondaryText, props);
};
var Link = function Link(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SLink, props);
};
var Paragraph = function Paragraph(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SParagraph, props);
};
var MessageLabel = function MessageLabel(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SMessageLabel, props);
};

function _templateObject$e() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$e = function _templateObject() {
        return data;
    };
    return data;
}
var SVerificationCode = styled$1(VerificationCode$1)(_templateObject$e());

var VerificationCode = function VerificationCode(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SVerificationCode, props);
};

function _templateObject$d() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$d = function _templateObject() {
        return data;
    };
    return data;
}
var SButton = styled(Button$1)(_templateObject$d());

var Button = function Button(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SButton, props);
};

function _templateObject$c() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$c = function _templateObject() {
        return data;
    };
    return data;
}
var SAvatar = styled$1(Avatar$1)(_templateObject$c());

var Avatar = function Avatar(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SAvatar, props);
};

function _templateObject$b() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$b = function _templateObject() {
        return data;
    };
    return data;
}
var SDivider = styled$1(Divider$1)(_templateObject$b());

var Divider = function Divider(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SDivider, props);
};

function _templateObject$a() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$a = function _templateObject() {
        return data;
    };
    return data;
}
var SCard = styled$1(Card$1)(_templateObject$a());

var Card = function Card(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SCard, props);
};

function _templateObject$9() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$9 = function _templateObject() {
        return data;
    };
    return data;
}
var SSpace = styled$1(Space$1)(_templateObject$9());

var Space = function Space(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SSpace, props);
};

function _templateObject$8() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$8 = function _templateObject() {
        return data;
    };
    return data;
}
var SCollapse = styled$1(Collapse$1)(_templateObject$8());

var Collapse = function Collapse(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SCollapse, props);
};

function _templateObject$7() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var STag = styled$1(Tag$1)(_templateObject$7());
var SCheckableTag = styled$1(CheckableTag$1)(_templateObject1());

var Tag = function Tag(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(STag, props);
};
var CheckableTag = function CheckableTag(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SCheckableTag, props);
};

var useShowToastNotification = function useShowToastNotification() {
    var notification = App.useApp().notification;
    var t = useTranslation({
        keyPrefix: 'descriptions.messages'
    }).t;
    var showToastNotification = function showToastNotification(param) {
        var message = param.message, type = param.type;
        var toastMessage = message;
        if (type === ENotificationType.ERROR && !message) {
            toastMessage = t('error.SOMETHING_WENT_WRONG');
        }
        notification.open({
            message: toastMessage,
            type: type,
            className: 'custom-notification',
            closeIcon: /*#__PURE__*/ React.createElement(Icon, {
                size: 24,
                icon: EIconNames.CLOSE,
                alt: "close icon of notification",
                "data-testid": "notification-close-icon",
                color: "#fff"
            }),
            placement: 'bottom'
        });
    };
    return {
        showToastNotification: showToastNotification
    };
};

function _templateObject$6() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$6 = function _templateObject() {
        return data;
    };
    return data;
}
var STextIcon = styled$1(TextIcon$1)(_templateObject$6());

var TextIcon = function TextIcon(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(STextIcon, props);
};

function _templateObject$5() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$5 = function _templateObject() {
        return data;
    };
    return data;
}
var SSpinner = styled$1(Spinner$1)(_templateObject$5());

var Spinner = function Spinner(props) {
    return /*#__PURE__*/ React.createElement(SSpinner, props);
};

function _templateObject$4() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$4 = function _templateObject() {
        return data;
    };
    return data;
}
var SEmptyView = styled$1(EmptyView$1)(_templateObject$4());

var EmptyView = function EmptyView(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SEmptyView, props);
};

function _templateObject$3() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$3 = function _templateObject() {
        return data;
    };
    return data;
}
var SQRCode = styled$1(QRCode$1)(_templateObject$3());

var QRCode = function QRCode(props) {
    return /*#__PURE__*/ React.createElement(SQRCode, props);
};

function _templateObject$2() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$2 = function _templateObject() {
        return data;
    };
    return data;
}
var SSwitch = styled$1(Switch$1)(_templateObject$2());

var Switch = function Switch(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SSwitch, props);
};

function _templateObject$1() {
    var data = _tagged_template_literal_loose([
        ""
    ]);
    _templateObject$1 = function _templateObject() {
        return data;
    };
    return data;
}
var SModal = styled$1(Modal$1)(_templateObject$1());

var Modal = function Modal(_0) {
    _object_destructuring_empty(_0); var props = _extends({}, _0);
    return /*#__PURE__*/ React.createElement(SModal, props);
};

var getMaskEmail = function getMaskEmail(email) {
    var _email_split = email.split('@'), name = _email_split[0], domain = _email_split[1];
    var maskedName = name.substring(0, 3) + '*'.repeat(name.length - 3);
    return maskedName + "@" + domain;
};
var generateSpaceClassNames = function generateSpaceClassNames(array) {
    var classNames = "";
    array.forEach(function(n, i) {
        classNames += "\n                .mx-" + i + " {\n                    margin: 0 " + n + "px !important;\n                }\n                .my-" + i + " {\n                    margin: " + n + "px 0 !important;\n                }\n                .m-" + i + " {\n                    margin: " + n + "px !important;\n                }\n                .mt-" + i + " {\n                    margin-top: " + n + "px !important;\n                }\n                .mb-" + i + " {\n                    margin-bottom: " + n + "px !important;\n                }\n                .ml-" + i + " {\n                    margin-left: " + n + "px !important;\n                }\n                .mr-" + i + " {\n                    margin-right: " + n + "px !important;\n                }\n                .pt-" + i + " {\n                    padding-top: " + n + "px !important;\n                }\n                .pb-" + i + " {\n                    padding-bottom: " + n + "px !important;\n                }\n                .pl-" + i + " {\n                    padding-left: " + n + "px !important;\n                }\n                .pr-" + i + " {\n                    padding-right: " + n + "px !important;\n                }\n                .px-" + i + " {\n                    padding: 0 " + n + "px !important;\n                }\n                .py-" + i + " {\n                    padding: " + n + "px 0 !important;\n                }\n                .p-" + i + " {\n                    padding: " + n + "px !important;\n                }\n            ";
    });
    return classNames;
};
var filterTitleOption = function filterTitleOption(input, option) {
    var _ref;
    return ((_ref = option == null ? void 0 : option.title) != null ? _ref : '').toLowerCase().includes(input.toLowerCase());
};
var filterLabelOption = function filterLabelOption(input, option) {
    var _ref;
    return ((_ref = option == null ? void 0 : option.label) != null ? _ref : '').toLowerCase().includes(input.toLowerCase());
};
var getFileViewerUrl = function getFileViewerUrl(fileUrl) {
    var extension = fileUrl.split('.').pop().toLowerCase();
    switch(extension){
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
        case 'ppt':
        case 'pptx':
            return "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(fileUrl);
        case 'pdf':
            return fileUrl; // Let the browser handle PDF files
        case 'png':
        case 'jpg':
        case 'jpeg':
            return fileUrl; // Let the browser handle image files
        default:
            return null;
    }
};

var appSessionStorage = {
    getItem: function getItem(key) {
        var item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    },
    setItem: function setItem(key, value) {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    },
    removeItem: function removeItem(key) {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    },
    clear: function clear() {
        try {
            sessionStorage.clear();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }
};
var appLocalStorage = {
    getItem: function getItem(key) {
        var item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    },
    setItem: function setItem(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    },
    removeItem: function removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    },
    clear: function clear() {
        try {
            localStorage.clear();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }
};

function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  && {\n    font-weight: 500 !important;\n    ",
        ",\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var SRequiredLabel = styled(Paragraph)(_templateObject(), requiredAsteriskStyles);

export { Avatar, Button, Card, CheckableTag, ChildcareView, Collapse, Divider, EI18nLanguageUI, EWorkshopChildcareAgeGroups, EditChildcare, EditableContentWithActions, EmptyView, Form, FormItem, FormList, Image, Input, Link, MessageLabel, Modal, Paragraph, PasswordInput, PhoneInput, QRCode, SRequiredLabel, SecondaryText, Space, Spinner, Switch, Tag, Text, TextArea, TextIcon, Title, VerificationCode, appLocalStorage, appSessionStorage, filterLabelOption, filterTitleOption, generateSpaceClassNames, getFileViewerUrl, getMaskEmail, useForm, useGetValidationData, useScreenSize, useShowToastNotification, useStateSafely, useStateSafelyNoParams, useTranslation };
